import { Link } from 'react-router-dom'
import NavBar from '../components/layout/NavBar'

export default function SubscribeCancel() {
  return (
    <div className="min-h-screen">
      <NavBar />
      <main className="mx-auto max-w-2xl px-4 py-16">
        <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
          <h1 className="text-2xl font-extrabold">Checkout canceled</h1>
          <p className="mt-2 text-white/80">No changes were made to your subscription.</p>
          <div className="mt-5 flex flex-wrap gap-2">
            <Link to="/pricing" className="rounded-xl bg-brand px-4 py-2 font-semibold">
              Back to pricing
            </Link>
            <Link to="/settings/billing" className="rounded-xl border border-white/20 px-4 py-2 text-white/85">
              Billing settings
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
}
